// extracted by mini-css-extract-plugin
export var chip = "_bc-0";
export var filterDropdown = "_bc-5";
export var filterItem = "_bc-6";
export var icon = "_bc-1";
export var removeButton = "_bc-3";
export var removeIcon = "_bc-4";
export var separator = "_bc-2";